import request from '@/utils/request'

export function getUserAccountInfo(data) {
  return request({
    url: '/api/common/v1/user/getUserAccountInfo',
    method: 'post',
    data
  })
}

export function getUserSpaceInfo(data) {
  return request({
    url: '/api/common/v1/user/getUserSpaceInfo',
    method: 'post',
    data
  })
}

export function getSpaceDetailInfo(data) {
  return request({
    url: '/api/common/v1/user/getSpaceDetailInfo',
    method: 'post',
    data
  })
}


export function replyInviteUserApi(data) {
  return request({
    url: '/companyUser/replyInviteUser',
    method: 'post',
    data
  })
}

export function deleteCompanyApi(data) {
  return request({
    url: '/companyUser/deleteCompany',
    method: 'post',
    data
  })
}

export function setTenantApi(data) {
  return request({
    url: 'system/user/setTenantId',
    method: 'post',
    data
  })
}


export function setTenantIdApi(data) {
  return request({
    url: '/api/common/v1/tool/setTenantId',
    method: 'post',
    data
  })
}

export function companyAuthAndSealCon(data) {
  return request({
    url: '/api/common/v1/user/companyAuthAndSealCon',
    method: 'post',
    data
  })
}

